export const formatFirmName = (distro: { name: string; healthClaimDistroId?: string | null }) =>
  distro.healthClaimDistroId?.trim() ? `${distro.name} (${distro.healthClaimDistroId.trim()})` : distro.name;
